import Stepper from '@/modules/core/components/shared/Stepper/Stepper'

export default Stepper
